import { deleteConfirmModal } from "@helpers/DeleteValidate";
import { errorHandler } from "@helpers/errorHandler";
import { Call } from "@helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "@redux/actions/administrador/ui/ui";
import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

const initialState = {
    list: [],
    active: null,
    activeDashboard: null,
    pagination: {
        current_page: 1,
        per_page: 15,
        total: 0,
        last_page: 1,
    },
};

const portfoliosSlice = createSlice({
    name: "portfolios",
    initialState,
    reducers: {
        setList(state, action) {
            state.list = action.payload;
        },
        unsetList(state) {
            state.list = initialState.list;
        },
        setActive(state, action) {
            state.active = action.payload;
        },
        unsetActive(state) {
            state.active = initialState.active;
        },
        setActiveDashboard(state, action) {
            state.activeDashboard = action.payload;
        },
        unsetActiveDashboard(state) {
            state.activeDashboard = initialState.activeDashboard;
        },
        setPagination(state, action) {
            state.pagination = action.payload;
        },
        unsetPagination(state) {
            state.pagination = initialState.pagination;
        },
        reset(state) {
            Object.assign(state, initialState);
        },
    },
});

export const {
    setList,
    unsetList,
    setActive,
    unsetActive,
    setActiveDashboard,
    unsetActiveDashboard,
    setPagination,
    unsetPagination,
    reset,
} = portfoliosSlice.actions;

export default portfoliosSlice.reducer;

/* -------------------------------------------------------------------------- */
/*                                   THUNKS                                   */
/* -------------------------------------------------------------------------- */

export const startShowPortfolios = ({
    page = 1,
    query = "",
    number_rows = 10,
    customer_id,
    enterprise_id,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);
        if (enterprise_id) params.set("enterprise_id", enterprise_id);
        if (customer_id) params.set("customer_id", customer_id);

        const resp = await Call(
            "users/portfolios/show",
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setPagination(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startShowPortfolioById = (
    portfolio_id,
    callback = () => {},
    errorCallback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `users/portfolios/${portfolio_id}/detail`,
            "GET"
        );

        if (resp.success) {
            const { portfolio, dashboard } = resp.success;
            dispatch(setActive(portfolio));
            dispatch(setActiveDashboard(dashboard));
            callback();
        } else {
            errorHandler(resp);
            errorCallback();
        }

        dispatch(stopUILoading());
    };
};

export const startCreatePortfolio = (
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call("users/portfolios/create", "POST", values);

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Portafolio creado correctamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            callback();
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdatePortfolio = (
    portfolio_id,
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `users/portfolios/edit/${portfolio_id}`,
            "POST",
            values
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Portafolio actualizado.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            callback();
            dispatch(setActive(resp.success));
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDeletePortfolio = (portfolio_id, callback = () => {}) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `users/portfolios/delete/${portfolio_id}`,
                "DELETE"
            );

            if (resp.success) {
                Swal.fire({
                    title: "Eliminado",
                    text: "El portafolio fue eliminado.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 5000,
                });

                callback();
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};
